import {Component, OnDestroy} from '@angular/core';

import {Observable, Subject} from 'rxjs';

@Component({
  template: ''
})
export class Destroyable implements OnDestroy {

  public isDestroyed: boolean = false;
  public onDestroySubject: Subject<void> = new Subject();
  public componentDestroyed$: Observable<any> = this.onDestroySubject.asObservable();

  public ngOnDestroy(): void {
    this.isDestroyed = true;
    this.onDestroySubject.next();
    this.onDestroySubject.complete();
  }
}
